import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {EditableTextComponent} from "@webmate-web-core/shared/components/forms-commons/editable-text.component";
import {EditorModule} from "primeng/editor";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {EditableInlineTextComponent} from "@webmate-web-core/shared/components/forms-commons/editable-inlinetext.component";
import {MultiSelectWithCustomInputComponent} from "@webmate-web-core/shared/components/forms-commons/multiselect-with-custom-input.component";
import {InputTextModule} from "primeng/inputtext";
import {ButtonModule} from "primeng/button";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {CodeEditorModule} from "@acrodata/code-editor";
import {MultiSelectModule} from "primeng/multiselect";
import {InputGroupModule} from "primeng/inputgroup";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {EditablePopoverComponent} from '@webmate-web-core/shared/components/forms-commons/editable-popover.component';
import {PopoverModule} from 'primeng/popover';
import {SelectModule} from 'primeng/select';

@NgModule({
  declarations: [
      EditableInlineTextComponent,
      EditableTextComponent,
      MultiSelectWithCustomInputComponent,
      EditablePopoverComponent,
  ],
    imports: [
        CommonModule,
        EditorModule,
        ReactiveFormsModule,
        FormsModule,
        InputTextModule,
        ButtonModule,
        FontAwesomeModule,
        CodeEditorModule,
        MultiSelectModule,
        InputGroupModule,
        InputGroupAddonModule,
        PopoverModule,
        SelectModule,
    ],
  exports: [
      EditableInlineTextComponent,
      EditableTextComponent,
      MultiSelectWithCustomInputComponent,
      EditablePopoverComponent,
  ]
})
export class FormsCommonsModule {
}
